export const GetDefaultSearchSelections = (api, caseId) => {
  return api
    .transact("GetOnwardReferralDefaultSearchDetails", { caseId: caseId })
    .then((response) => {
        return response.apiResult;
    })
    .catch((e) => {
      return Promise.reject(e);
    });
};